/**
 * Created by Administrator on 2018/4/26.
 */
import { signIn, refreshToken, deleteToken } from '@/api/signIn'
import { getToken, setToken, removeToken } from '@/utils/auts'

const user = {
  state: {
    token: getToken()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },

  actions: {
    // 登录
  // Login({ commit }, userInfo) {
  //     const username = userInfo.username.trim()
  //     return new Promise((resolve, reject) => {
  //       const params = {
  //         username: username,
  //         password: userInfo.password
  //       }
  //       login(params).then(response => {
  //         const data = response
  //         setToken(data.access_token)
  //         commit('SET_TOKEN', data.access_token)
  //         resolve()
  //       }).catch(error => {
  //         reject(error)
  //       })
  //     })
  //   },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        deleteToken(state.token).then(() => {
          commit('SET_TOKEN', '')
          removeToken();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },


    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        localStorage.clear()
        resolve()
      })
    },

    // 前端 获取token
   SetToken({ commit }, token) {
      return new Promise(resolve => {
        commit('SET_TOKEN', token)
      })
    }
  }
}

export default user




// WEBPACK FOOTER //
// ./src/store/modules/user.js